import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Div, Icon, Label, Text } from '@pinpoint/design-kit';

function Card({
  title,
  cardProps,
  titleProps,
  titleTextProps,
  iconProps,
  children,
  hasSelection,
  isSelected,
  onSelect,
  onDeselect,
}) {
  return (
    <Div w="100%" bg="white" p={{ x: '1.5rem', y: '1.25em' }} rounded="md" {...cardProps}>
      <Div
        w="100%"
        bg="secondary"
        rounded="sm"
        p={{ l: '1rem', r: '1rem' }}
        d="flex"
        justify="space-between"
        align="center"
        {...titleProps}
      >
        <Div w={iconProps && iconProps.name ? 'calc(100% - 30px)' : '100%'} d="flex" align="center">
          {hasSelection ? (
            <Div
              cursor="pointer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (isSelected) {
                  onDeselect();
                } else {
                  onSelect();
                }
              }}
              m={{ r: '.8em' }}
            >
              <Label>
                <Checkbox
                  // @ts-ignore
                  checked={isSelected}
                  m={{ r: '0.5rem' }}
                />
              </Label>
            </Div>
          ) : null}
          <Text p={{ y: '.95em' }} textSize="subtitle" {...titleTextProps}>
            {title}
          </Text>
        </Div>
        {iconProps && iconProps.name ? <Icon {...iconProps} /> : null}
      </Div>
      {children}
    </Div>
  );
}

Card.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cardProps: PropTypes.shape({}),
  titleProps: PropTypes.shape({}),
  titleTextProps: PropTypes.shape({}),
  iconProps: PropTypes.objectOf(PropTypes.string),
  hasSelection: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onDeselect: PropTypes.func,
};

Card.defaultProps = {
  title: null,
  cardProps: {},
  titleProps: {},
  titleTextProps: {},
  iconProps: {},
  hasSelection: false,
  isSelected: false,
  onSelect: () => null,
  onDeselect: () => null,
};

export default Card;
